<template>
	<div>
		<p class="view_head">申报单位基本信息</p>
		<div style="display: flex;flex-wrap: wrap;">
			<div data-v-022fc800="" class="labelInput" style="width: 520px;">
				<span class="innerSpan" style="color: rgb(0, 0, 0); font-size: 14px; width: 150px;">
					<span style="color: red;">*&nbsp;</span>单位名称:</span>
				<div class="innerP" style="width: auto; font-size: 14px;">
					<div class="el-tooltip el-input" aria-describedby="el-tooltip-1847" tabindex="0">
						<el-input disabled v-model="this.company_name" />
					</div>
				</div>
			</div>
			<div data-v-022fc800="" class="labelInput" style="width: 520px;">
				<span class="innerSpan" style="color: rgb(0, 0, 0); font-size: 14px; width: 150px;">
					<span style="color: red;">*&nbsp;</span>统一社会信用代码:</span>
				<div class="innerP" style="width: auto; font-size: 14px;">
					<div class="el-tooltip el-input" aria-describedby="el-tooltip-1847" tabindex="0">
						<el-input disabled v-model="this.tax_number" />
					</div>
				</div>
			</div>
			<labelInput :outInput="newform.contact_dep" :spanRequired="true" normalPlace="请输入联系部门"
				@inputChange="labelInput($event,'contact_dep')" spanTitle="联系部门" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.contact_name" :spanRequired="true" normalPlace="请输入联系人"
				@inputChange="labelInput($event,'contact_name')" spanTitle="联系人" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.phone" :spanRequired="true" normalPlace="请输入手机电话"
				@inputChange="labelInput($event,'phone')" spanTitle="手机电话" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.zip_code" :spanRequired="true" normalPlace="请输入邮编"
				@inputChange="labelInput($event,'zip_code')" spanTitle="邮编" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<div style="display: flex;align-items: center;height: 40px;width: 93%;">
				<label-select ref="labelAddres" componentWidth="550px" :spanRequired="true"
					@placeInfo="place1Info($event,'[province,city,area]')" @placeLevel="tongLevel = $event"
					:spanWidth="spanWidth" spanTitle="通讯地址">
				</label-select>
				<el-input v-model="newform.address" @blur="labelInput(newform.address,'address')"
					style="width: 520px;margin-left: 40px;" placeholder="请输入详细地址">
				</el-input>
			</div>
		</div>
		<p class="view_head">QC小组信息</p>
		<div style="display: flex;flex-wrap: wrap;">
			<labelInput :outInput="newform.group_name" :spanRequired="true" normalPlace="请输入小组名称"
				@inputChange="labelInput($event,'group_name')" spanTitle="小组名称" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.group_person" :spanRequired="true" normalPlace="请输入小组人数(小于等于12人)"
				@inputChange="labelInput($event,'group_person')" spanTitle="小组人数" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.achievement_name" :spanRequired="true" normalPlace="请输入课题名称"
				@inputChange="labelInput($event,'achievement_name')" spanTitle="课题名称" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<div class="qc_list">
				<p><span style="color: red;margin-right: 10px;">*</span>课题类型:</p>
				<div class="qc_list__Right">
					<el-select v-model="newform.achievement_type" style="width: 350px;"
						@change="labelInput(newform.achievement_type,'achievement_type')" placeholder="请选择">
						<el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>
			<labelInput :outInput="newform.instructor_name" :spanRequired="true" normalPlace="请输入小组活动指导者姓名"
				@inputChange="labelInput($event,'instructor_name')" spanTitle="小组活动指导者姓名" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
<!--			<div class="qc_list">
				<p><span style="color: red;margin-right: 10px;">*</span>是否需发表:</p>
				<div class="qc_list__Right">
					<el-radio-group v-model="newform.is_publish" @change="labelInput(newform.is_publish,'is_publish')">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="2">否</el-radio>
					</el-radio-group>
				</div>
			</div>-->
			<labelInput :outInput="newform.main_member" :spanRequired="true" normalPlace="请输入小组参与人员"
				specilType="textarea" :maxLimit="100" :outRow="2" @inputChange="labelInput($event,'main_member')"
				spanTitle="小组参与人员" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.publish_name" :spanRequired="true" normalPlace="请输入发表人姓名"
				@inputChange="labelInput($event,'publish_name')" spanTitle="发表人姓名" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<div style="width: 540px;">
			</div>
			<labelInput :outInput="newform.publish_phone" :spanRequired="true" normalPlace="请输入发表人电话"
				@inputChange="labelInput($event,'publish_phone')" spanTitle="发表人电话" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>

			<labelInput :outInput="newform.completion_certificate" :spanRequired="true" normalPlace="请输入指导人资格证书编号"
				@inputChange="labelInput($event,'completion_certificate')" spanTitle="指导人资格证书编号" spanWidth="150px"
				componentWidth="520px">
			</labelInput>

			<labelInput :outInput="newform.issue_unit" :spanRequired="true" normalPlace="请输入证书发证机构"
				@inputChange="labelInput($event,'issue_unit')" spanTitle="证书发证机构" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>

			<labelInput :outInput="newform.group_desp" specilType="textarea" :maxLimit="500" :outRow="3"
				:spanRequired="true" normalPlace="请输入小组简介" @inputChange="labelInput($event,'group_desp')"
				spanTitle="小组简介" :spanWidth="spanWidth" componentWidth="92%">
			</labelInput>
			<labelInput :outInput="newform.activity" specilType="textarea" :maxLimit="700" :outRow="4"
				:spanRequired="true" normalPlace="请输入主要活动过程及效果" @inputChange="labelInput($event,'activity')"
				spanTitle="主要活动过程及效果" :spanWidth="spanWidth" componentWidth="92%">
			</labelInput>
		</div>

	</div>
</template>

<script>
	import {
		getCompanyNames,
		getTaxNumber,
	} from "@/api/moudles/user.js"
	import {
		getLoginCompany
	} from '@/api/moudles/manager.js'
	import labelInput from '../../../components/table/labelInput.vue'
	import labelSelect from '../../../components/table/labelSelect.vue'

	export default {
		data() {
			return {
				company_name: '',
				tax_number: '',
				newform: {},
				spanWidth: '150px',
				// 推荐单位
				options: [{
					name: '问题解决型',
					value: '2'
				}, {
					name: '创新型',
					value: '1'
				}],
				projectCode: '',
			}
		},
		components: {
			labelInput,
			labelSelect,
		},
		created() {
			if (this.$route.params.projectCode) {
				this.projectCode = this.$route.params.projectCode
			}
			this.getLoginCompany()
		},
		props: {
			datas: {
				type: Object,
				default: () => {}
			},
		},
		watch: {
			datas(newValue) {
				if (newValue) {
					newValue.is_publish = parseInt(newValue.is_publish)
					newValue.achievement_type = String(newValue.achievement_type)
					setTimeout(() => {
						this.newform = {
							...newValue
						}
					})
					this.$refs.labelAddres.refAddData([newValue.province ? newValue.province : '',
						newValue.city ? newValue.city : ''
					])
				} else {
					this.$refs.labelAddres.refAddData(['', ''])
				}
			}
		},
		methods: {
			// 获取登录人公司信息
			getLoginCompany() {
				getLoginCompany({
					success: res => {
						this.company_name = res.data.companyName
						this.tax_number = res.data.tax_number
					}
				})
			},
			labelInput(e, name) {
				// console.log(e, name)
				this.newform[name] = e
				this.$emit('reciveData', [name, e])
			},
			place1Info(e, name) {
				if (e.length > 1) {
					// [province,city,area]
					this.newform['province'] = e[0]
					this.newform['city'] = e[1]
					this.$emit('reciveData', ['province', e[0]])
					this.$emit('reciveData', ['city', e[1]])
				}
			},
		}
	}
</script>

<style scoped>
	.view_head {
		font-size: 18px;
		font-weight: bold;
		margin-top: 20px;
	}

	.qc_list {
		display: flex;
		align-items: center;
		margin: 10px;
	}

	.qc_newAdd {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 92%;
		margin-bottom: 10px;
	}


	.qc_clumView {
		display: flex;
		flex-flow: column;
		margin: 10px;
		padding-left: 80px;
		/* padding-left: 170px; */
	}

	.qc_clumView p {
		text-align: left;
		font-size: 14px;
		display: inline-block;
		margin-bottom: 10px;
	}

	.qc_clumView_right {
		width: 92%;
	}

	.qc_list__Right {
		padding-left: 20px;
	}

	.qc_list p {
		font-size: 14px;
		width: 150px;
		text-align: right;
		display: inline-block;
	}
</style>
